/**
 * Persists in-flight catalog sync metadata for the current browser tab session.
 * ASSUMPTION: Cleared on logout via clearSessionRequestCache / manual clear.
 */

export const CATALOG_SYNC_SESSION_KEY = "catalog:sync:active";

export interface CatalogSyncSession {
  startedAt: number;
  processTypeId: number;
  /** Highest log id observed before starting this sync run. */
  baselineLogId: number;
}

export function getCatalogSyncSession(): CatalogSyncSession | null {
  try {
    const raw = sessionStorage.getItem(CATALOG_SYNC_SESSION_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as CatalogSyncSession;
    if (
      typeof parsed.startedAt !== "number" ||
      typeof parsed.processTypeId !== "number" ||
      typeof parsed.baselineLogId !== "number"
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function setCatalogSyncSession(session: CatalogSyncSession): void {
  sessionStorage.setItem(CATALOG_SYNC_SESSION_KEY, JSON.stringify(session));
}

export function clearCatalogSyncSession(): void {
  sessionStorage.removeItem(CATALOG_SYNC_SESSION_KEY);
}

export function hasActiveCatalogSyncSession(maxWaitMs: number): boolean {
  const session = getCatalogSyncSession();
  if (!session) return false;
  return Date.now() <= session.startedAt + maxWaitMs;
}
